var masterySkills = ["formula_mastery", "whip_mastery", "sword_mastery", "gun_mastery", "curse_mastery", "spear_mastery", "sword_mastery", "axe_mastery", "heal_mastery", "shield_mastery", "katana_mastery", "bow_mastery", "song_mastery"];
    export default masterySkills;
    